import { Badge as Badge_ } from "@chakra-ui/react";
import { forwardRef } from "react";
export const Badge = forwardRef(({ ...props }, ref) => {
    return <Badge_ ref={ref} {...props}>{props?.children}</Badge_>
});